import Checkers from "./class/Checkers";

const MAX_VISIBLE_FACILITIES = 4;

export function facilitiesSummary ( facilities ) : string | null {
    if ( !Checkers.isValidArray( facilities ) ) {
        return null;
    }
    const visible = facilities.slice( 0, MAX_VISIBLE_FACILITIES );
    const rest = facilities.length - visible.length;
    return visible.join( ' · ' ) + ( rest > 0 ? ' · +' + rest + ' more' : '' );
}

export function mergeFacilities ( areas ) : Array<string> {
    if ( !Checkers.isValidArray( areas ) ) {
        return [];
    }
    return Array.from( new Set( areas.flatMap( ( area ) => Checkers.isValidArray( area.facilities ) ? area.facilities : [] ) ) );
}

export function featureGroupsToFacilities ( groups ) : Array<string> {
    if ( !Checkers.isValidArray( groups ) ) {
        return [];
    }
    const labels : Array<string> = [];
    groups.forEach( ( group ) => {
        ( Checkers.isValidArray( group.features ) ? group.features : [] ).forEach( ( feature ) => {
            if ( !Checkers.isValidString( feature.feature_title ) ) {
                return;
            }
            let label = feature.feature_title;
            if ( Checkers.isValidArray( feature.feature_options ) && Checkers.isValidString( feature.feature_options[0].option_value ) ) {
                label += ' ' + feature.feature_options[0].option_value;
            } else if ( feature.feature_value != null && String( feature.feature_value ) !== '1' && String( feature.feature_value ).trim() !== '' && !Array.isArray( feature.feature_value ) ) {
                label += ' ' + feature.feature_value;
            }
            labels.push( label.replace( /\s+/g, ' ' ).trim() );
        } );
    } );
    return labels;
}
